export const REGION = 'asia-south1';

export const APP_NAME = 'TrackerBuddy';
export const TOG_APP_NAME = 'TOGtracker';
export const BACKUP_PREFIX = 'TrackerBuddy_Backup_';
export const TOG_BACKUP_PREFIX = 'TOG_Backup_';

export const COLLECTIONS = {
    USERS: 'users',
    TEAMS: 'teams',
    MEMBER_SUMMARIES: 'member_summaries',
    CONFIG: 'config',
    APP_CONFIG: 'app_config',
    PRO_WHITELIST: 'pro_whitelist'
};

export const USER_ROLES = {
    STANDARD: 'standard',
    PRO: 'pro',
    CO_ADMIN: 'co-admin'
};

export const TEAM_ROLES = {
    ADMIN: 'admin',
    MEMBER: 'member'
};

export const LEAVE_DAY_TYPES = {
    FULL: 'full',
    HALF: 'half'
};

export const VIEW_MODES = {
    MONTH: 'month',
    DAY: 'day'
};

export const ACTION_TYPES = {
    SAVE_NOTE: 'SAVE_NOTE',
    ADD_SLOT: 'ADD_SLOT',
    UPDATE_ACTIVITY_TEXT: 'UPDATE_ACTIVITY_TEXT',
    UPDATE_TIME: 'UPDATE_TIME'
};

export const COLOR_MAP = {
    '#ef4444': 'Red',
    '#f97316': 'Orange',
    '#eab308': 'Yellow',
    '#84cc16': 'Lime',
    '#22c55e': 'Green',
    '#14b8a6': 'Teal',
    '#06b6d4': 'Cyan',
    '#1d4ed8': 'Blue',
    '#8b5cf6': 'Violet',
    '#d946ef': 'Fuchsia',
    '#ec4899': 'Pink',
    '#78716c': 'Gray'
};

export const DEFAULT_TIME_SLOTS = {
    START_HOUR: 8,
    END_HOUR: 18
};

export const LONG_PRESS_DURATION = 500;

export const NOTIFICATION_TIMEOUT = 3000;

// Industry standard capping limit for half-day leave total hours
export const HALF_DAY_CAPPING_MAX_HOURS = 5.2;

export const LOCAL_STORAGE_KEYS = {
    SESSION_MODE: 'sessionMode',
    GUEST_USER_DATA: 'guestUserData',
    THEME: 'theme',
    APP_LANGUAGE: 'appLanguage',
    REAL_TIME_UPDATES: 'realTimeUpdates',
    LAST_SYNC_TIME: 'lastSyncTime',
    LAST_VIEW_MODE: 'lastViewMode',
    LAST_TRACKER_VIEW: 'lastTrackerView',
    TOG_DATA: 'tog_tracker_v1',
    HAS_SEEN_LEAVE_HELP: 'tb_has_seen_leave_help',
    HAS_SEEN_PLUS_TOOLTIP: 'tb_has_seen_plus_tooltip',
    HAS_SEEN_TOG_HELP: 'tb_has_seen_tog_help',
    HAS_SEEN_TOG_OVERLAY_MODAL: 'tb_has_seen_tog_overlay_modal',
    DEFAULT_START_HOUR: 'tb_default_start_hour',
    DEFAULT_END_HOUR: 'tb_default_end_hour'
};

export const NOTIFICATION_SHAPE = 'rounded-full';

export const AVATAR_GRADIENTS = [
    'linear-gradient(135deg, #6366F1 0%, #A855F7 100%)',   // Indigo -> Purple
    'linear-gradient(135deg, #EC4899 0%, #F43F5E 100%)',   // Pink -> Rose
    'linear-gradient(135deg, #3B82F6 0%, #2DD4BF 100%)',   // Blue -> Teal
    'linear-gradient(135deg, #F59E0B 0%, #EF4444 100%)',   // Amber -> Red
    'linear-gradient(135deg, #10B981 0%, #06B6D4 100%)',   // Emerald -> Cyan
    'linear-gradient(135deg, #8B5CF6 0%, #EC4899 100%)',   // Violet -> Pink
    'linear-gradient(135deg, #F97316 0%, #FBBF24 100%)',   // Orange -> Amber
    'linear-gradient(135deg, #06B6D4 0%, #3B82F6 100%)',   // Cyan -> Blue
    'linear-gradient(135deg, #14B8A6 0%, #10B981 100%)',   // Teal -> Emerald
    'linear-gradient(135deg, #A855F7 0%, #6366F1 100%)',   // Purple -> Indigo
    'linear-gradient(135deg, #D946EF 0%, #8B5CF6 100%)',   // Fuchsia -> Violet
    'linear-gradient(135deg, #0284C7 0%, #2563EB 100%)',   // Sky -> Blue
    'linear-gradient(135deg, #EA580C 0%, #DC2626 100%)',   // Dark Orange -> Crimson
    'linear-gradient(135deg, #059669 0%, #0D9488 100%)',   // Deep Emerald -> Deep Teal
    'linear-gradient(135deg, #7C3AED 0%, #4F46E5 100%)',   // Deep Violet -> Deep Indigo
    'linear-gradient(135deg, #E11D48 0%, #9333EA 100%)'    // Rose -> Purple
];

export function getUserAvatarGradient(seed) {
    if (!seed) return AVATAR_GRADIENTS[0];
    let hash = 0;
    const str = String(seed);
    for (let i = 0; i < str.length; i++) {
        hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
    }
    return AVATAR_GRADIENTS[hash % AVATAR_GRADIENTS.length];
}

export function generateAvatarSVG(seed, initial = 'U', size = 36) {
    const letter = (initial || 'U').charAt(0).toUpperCase();
    const grad = getUserAvatarGradient(seed);
    const fontSize = Math.round(size * 0.48);
    return `<div style="width:100%;height:100%;background:${grad};border-radius:9999px;display:flex;align-items:center;justify-content:center;color:#ffffff;font-weight:700;font-size:${fontSize}px;user-select:none;box-shadow:0 1px 2px rgba(0,0,0,0.15);">${letter}</div>`;
}
